import { useSelector } from 'react-redux';
import { ClinicInsights, useGetClinicsDashboardQuery } from '../../api/clinics';
import { useDateRange } from '../../hooks/useDateRange';
import { getTenantIds } from '../../stores/slices/preferences';

export function useClinicsInsights({ dateRange }: { dateRange: [Date, Date] | null }): {
  isLoading: boolean;
  data: Array<ClinicInsights & { tenantId: string }>;
} {
  const tenantIds = useSelector(getTenantIds());
  const { dateFrom, dateTo } = useDateRange(dateRange);

  const { data, isLoading } = useGetClinicsDashboardQuery({ tenantIds, dateFrom, dateTo });

  const insights =
    Object.entries(data?.tenantInsights ?? {})
      .filter(([tenantId]) => !tenantIds || tenantIds.includes(tenantId))
      .map(([tenantId, value]) => {
        return {
          tenantId,
          ...value,
          avgRepsPerSession: Number(value.avgRepsPerSession.toFixed(2)),
          avgTimeTakenPerSession: Number(value.avgTimeTakenPerSession.toFixed(2)),
          avgTotalRepsPerPatient: Number(value.avgTotalRepsPerPatient.toFixed(2)),
          avgTimeTakenPerPatient: Number(value.avgTimeTakenPerPatient.toFixed(2))
        };
      })
      .sort((a, b) => a.label.localeCompare(b.label)) ?? [];

  return { data: insights, isLoading };
}
